<!-- 用户下拉菜单组件 -->
<template>
  <el-dropdown trigger="click" menuAlign="end">

    <span class="el-dropdown-link">
      {{username}}
      <i class="el-icon-caret-bottom el-icon--right"></i>
    </span>

    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item>修改密码</el-dropdown-item>
      <el-dropdown-item divided><span @click="loginOut">退出平台</span></el-dropdown-item>
    </el-dropdown-menu>

  </el-dropdown>
</template>
<script type="text/javascript">
  import $ from 'jquery'

  export default {
    name:'user',
    data: function(){
      return {
        username: ""
      }
    },
    created(){
      this.request();
    },
    methods: {
      request: function(){
        var vm = this
        // $.ajax({
        //   type:"get",
        //   url:"http://localhost:3000/api",
        //   success:function(re){
        //     vm.username = re.type.profile.data.name
        //   }
        // })
//          vm.user = {
//            name:'丁锐峰'
//          };
        this.username = "丁锐峰"

      },
      loginOut: function(){
          //this.username = "未登录"
          window.location.href = "login.html";
      }
    }
  }

</script>
<style media="screen">
  .el-dropdown{cursor: pointer; width: 200px;height: 58px;text-align: center;}
  .el-dropdown:hover{background: rgb(9,159,229);}
  .el-dropdown-menu{width: 200px;}
  .el-dropdown-link{width: 200px;height: 60px;display: inline-block;}
</style>



// WEBPACK FOOTER //
// user.vue?ccd4bbde